"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runHook = void 0;
var flowright = require("lodash.flowright");
var build_app_data_1 = require("./hook-context/build-app-data");
var execution_timer_plugin_1 = require("./utility-plugins/execution-timer-plugin");
var enablePluginTimer = (function () {
    /*
      Putting this check inside a function so it can be wrapped in a try/catch, just in case
      the minifier does something weird and we get a `ReferenceError: process is undefined` error.
    */
    try {
        return typeof process === 'object' && process.env && process.env.ENABLE_PLUGIN_TIMER;
    }
    catch (error) {
        console.error(error);
    }
    return false;
})();
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var terminatingReducer = function (accumulator, context) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        // resolve an empty object to start the return phase of the chain
        return [2 /*return*/, {}];
    });
}); };
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var terminatingTimerReducer = function (accumulator, context) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        console.log('#terminatingPlugin() time to start working backwards!');
        return [2 /*return*/, {
                forwardEndTime: Date.now(),
            }];
    });
}); };
/**
 * Higher order function to wrap plugin hook methods in a way that allows them
 * to properly execute within the hook chain, without disrupting the original hook method.
 *
 * @param pluginHook A reference to the plugin hook method that needs to be wrapped. This would basically be
 * something equivalent to `somePlugin.onBrowserWrapRootElement`.
 * @param transform An object with optional `pre` and `post` transform methods that will be run
 * before and after the provided plugin hook method.
 * These methods allow the hook executor to decorate the input or output for each plugin hook in the hook chain.
 */
var wrapPluginLink = function (pluginHook, transform) {
    /**
     * WrappedPluginHook will be the method that gets called for each plugin hook
     * when the collection is passed to flowright().
     *
     * The collection is processed from right to left with the result of each wrappedPluginHook (i.e. pluginHookReducer)
     * being passed to the next wrappedPluginHook.
     */
    var wrappedPluginHook = function (nextPluginHook) {
        /**
         * pluginHookReducer is the curried method that gets returned to the flowright() iterator.
         * That means the final result of flowright(...) is a chain of pluginHookReducer methods.
         */
        function pluginHookReducer(accumulator, context) {
            return __awaiter(this, void 0, void 0, function () {
                var pluginHookContext, pluginHookResult, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            pluginHookContext = context;
                            if (!(transform && typeof transform.pre === 'function')) return [3 /*break*/, 2];
                            return [4 /*yield*/, transform.pre(context)];
                        case 1:
                            pluginHookContext = _a.sent();
                            _a.label = 2;
                        case 2:
                            pluginHookResult = pluginHook(pluginHookContext, nextPluginHook.bind(null, accumulator));
                            if (!(transform && typeof transform.post === 'function')) return [3 /*break*/, 4];
                            return [4 /*yield*/, pluginHookResult];
                        case 3:
                            result = _a.sent();
                            return [2 /*return*/, transform.post(pluginHookContext, result)];
                        case 4: return [2 /*return*/, pluginHookResult];
                    }
                });
            });
        }
        var name = "reducer_".concat(pluginHook.name);
        Object.defineProperty(pluginHookReducer, 'name', {
            get: function () {
                return name;
            },
        });
        return pluginHookReducer;
    };
    return wrappedPluginHook;
};
/**
 * Runs all hooks that match the provided name.
 * @param plugins A list of plugins.
 * @param hookName Name of the hook to run.
 * @param context The arguments passed to every hook call.
 * @param transform Provide optional pre & post callbacks to modify the passed in arguments during hook execution.
 * @returns A list of non-undefined results.
 */
function runHook(plugins, hookName, context, transform, options) {
    return __awaiter(this, void 0, void 0, function () {
        var pluginState, pluginLinks, pluginChain, pluginChainInitiator, result;
        return __generator(this, function (_a) {
            if (!Array.isArray(plugins)) {
                return [2 /*return*/, null];
            }
            if ((options === null || options === void 0 ? void 0 : options.useState) && context.setAppData) {
                pluginState = (0, build_app_data_1.getPluginState)();
                context.setAppData(pluginState);
            }
            pluginLinks = plugins
                .filter(function (plugin) { return typeof plugin[hookName] === 'function'; })
                .map(function (plugin) {
                var transformProxy = {
                    pre: transform && typeof transform.pre === 'function' ? function (context) { var _a; return (_a = transform.pre) === null || _a === void 0 ? void 0 : _a.call(transform, context, plugin); } : null,
                    post: transform && typeof transform.post === 'function'
                        ? function (context, result) { var _a; return (_a = transform.post) === null || _a === void 0 ? void 0 : _a.call(transform, context, result); }
                        : null,
                };
                return wrapPluginLink(plugin[hookName], transformProxy);
            });
            if (pluginLinks.length > 0) {
                if (enablePluginTimer) {
                    pluginLinks.unshift(wrapPluginLink(execution_timer_plugin_1.executionTimerPlugin, {}));
                }
                pluginChain = flowright.apply(void 0, pluginLinks);
                pluginChainInitiator = pluginChain(enablePluginTimer ? terminatingTimerReducer : terminatingReducer);
                result = pluginChainInitiator([], __assign({}, context));
                result.then(function () {
                    if ((options === null || options === void 0 ? void 0 : options.saveState) && typeof context.getAppData === 'function') {
                        (0, build_app_data_1.setPluginState)(context.getAppData());
                    }
                });
                return [2 /*return*/, result];
            }
            return [2 /*return*/, null];
        });
    });
}
exports.runHook = runHook;
//# sourceMappingURL=hook-runner.js.map